<!--
    消息提示组件
    2020.11.30 姚政伟 封装
-->
<template>
    <div class="y-panel-msg">
        <img :src="ico" alt="" />
        <div class="msg">
            <div class="name">{{title}}</div>
            <div class="sub">{{content}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "YPanelMsg",
        props:{
            //图标
            ico:{
                type:String,
                default:''
            },
            //消息标题
            title:{
                type:String,
                default: ''
            },
            //消息内容
            content:{
                type:String,
                default: ''
            }
        }
    }
</script>

<style lang="less" scoped>
    .y-panel-msg {
        padding-top: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        .msg{
            color: #000;
            font-size: 17px;
            text-align: center;
            width: 70%;
            .name{
                padding: 27px 0;
            }
        }
        img {
            height: 60px;
        }
        .sub {
            font-size: 12px;
            color: #333;
            font-weight: 500;
            padding-bottom: 22px;
            margin: 0 auto;
        }
    }
</style>